
<div class="row" *ngIf="Breadcrumb!=null">
  <div class="col-12 p-0 border-bottom headersize">
    <app-breadcrumb [Breadcrumb]="Breadcrumb"></app-breadcrumb>
  </div>
</div>

<div clas="row">
  <div class="col-12" style="height:58vh !important; overflow: auto;">
    <form [formGroup]="AddStudyUnitform">

    <div class="col-12">
      <div class="row pt-2">
        <div class="col-2 text-right pr-0 pt-1 pl-0">
          <div class="d-flex  flex-row-reverse">
            <div class="p-0 label-red">*</div>
            <div class="p-0">Study Unit Name</div>
          </div>
        </div>
        <!-- <div class="col-10 pl-2">
          <input type="text" class="form-control form-control-sm input-txt" formControlName="Study_Unit_Name"/>
        </div> -->
        <div class="col-10 pl-2 text-right">
          <input
            type="text"
            maxlength="250"
            class="form-control form-control-sm input-txt"
            formControlName="Study_Unit_Name"
            [ngClass]="{'invalid': AddStudyUnitform.get('Study_Unit_Name')?.invalid && AddStudyUnitform.get('Study_Unit_Name')?.touched}"
          />

          <label class="form-check-label charlength">
            Characters {{subjectvaluelength}}/{{subjectMaxlength}}
          </label>

          <!-- Error Message -->
          <div class="invalid-feedback" *ngIf="AddStudyUnitform.get('Study_Unit_Name')?.hasError('required') && AddStudyUnitform.get('Study_Unit_Name')?.touched">
            Study Unit Name is required.
          </div>
        </div>

        <div class="col-2"></div>
        <div class="col-10"><label class="Valid1" *ngIf="namevalidate">Name Already Exists</label></div>
      </div>

  </div>
    <div class="col-12">
      <div class="row pt-2">
        <div class="col-2 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0 label-red">*</div>
            <div class="p-0">Display Order</div>
          </div>
        </div>
        <div class="col-6 pl-2">
          <input type="number" readonly onKeyPress="if(this.value.length==4) return false;" class="form-control form-control-sm input-txt w-25" formControlName="Display_Order" (ngModelChange)="Editformvalidation()"/>
        </div>
      </div>
    </div>
    <div class="col-12 text-right">
      <div class="row pt-2">
        <div class="col-2 text-right pr-0 pt-1 pl-0">
          <div class="d-flex  flex-row-reverse">
        <div class="p-0">Description</div></div> </div>
        <div class="col-10 pl-2">
          <textarea formControlName="Description_Text"  maxlength="4000" class="form-control input-txt1" id="txtAssignmentIntruction" (ngModelChange)="Descriptioncount()"></textarea>
          <label class="form-check-label maxlength" for="exampleCheck1">Characters {{Descriptionvaluelength}}/{{DescriptionMaxlength}}</label>
        </div>
        <div class="col-3 pr-0 pt-1 pl-0"></div>
      </div>
    </div>
    <div class="col-12">
      <div class="row px-1 pb-1">
        <div class="col-2" *ngIf="!EditStudyUnitflag"></div>
        <div class="col-10 my-3 text-danger d-flex align-items-center" *ngIf="!EditStudyUnitflag">
          <strong style="color: black;">Note:&nbsp;&nbsp;&nbsp; </strong> A study unit must have topics selected for it.
          Please click on <strong>'Select Topics for Study Unit'</strong> to proceed.
        </div>
        <div class="col-2" *ngIf="EditStudyUnitflag"></div>
        <div class="col-10 my-3 text-danger d-flex align-items-center" *ngIf="EditStudyUnitflag">
          <div class="" role="alert">
            <p style="color: red;"> <strong style="color:black">Note:</strong> Once a study unit is created at a certain subject hierarchy level,
           you cannot create a Study Unit at a lower or higher level for the same topic. Please pay attention while
           defining Study Units. <br>
           For example, if a Study Unit is defined for Electricity at the Major Topic or Concept
           level, all chapters must be defined at that level.
         </p>
         </div>
        </div>

      <div class="col-2">
      </div>
      <div class="col-10 px-3">
        <div class="d-flex">
          <div class="px-1">
            <!-- (click)="Add()" -->
            <button type="button" [disabled]='isSaveDisabled' (click)="AddStudyUnit()" class="btn btn-sm bl-btn">Save </button>
          </div>
          <div class="px-1">
            <!-- (click)="Add()" -->
            <button type="button" [disabled]='StudyUnitDetailsflag && AddStudyUnitflag' (click)="Cancel()" class="btn btn-sm bg-light border">Cancel</button>
          </div>
          <div class="px-1">
            <!-- (click)="Add()" -->
            <button type="button" [disabled]='!StudyUnitDetailsflag && AddStudyUnitflag' (click)="AddSubject()" class="btn btn-sm bg-light border">Select Topics for Study Units</button>
          </div>
          <div class="px-1">
            <!-- (click)="Add()" -->
            <button type="button" *ngIf="EditStudyUnitflag" (click)="RelocateTopic()" class="btn btn-sm bg-light border">Relocate Study Unit</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  </form>
  </div>
</div>




  <!-- <div class="modal fade  show modal-dialog-centered"style="padding-right: 4px;display: block;background-color: #00000075;" *ngIf="StudyUnitPopupflag">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border Page-Header p-1 py-0">
          <h6 class="HeadContent" id="QuestionTemplatetitle">Add Study Unit Topics</h6>
          <button type="button" class="close" (click)="CloseStudyUnitTopics()"
            style="padding-right: 20px;font-size: 30px;outline: 0;">
            <span aria-hidden="true">&times;</span></button>
        </div>

        <div class="modal-body px-3 py-0"> -->

        <!-- <app-content-studyunit-topics [StudyUnitID]="StudyUnitID" [subjectById]="subjectById"></app-content-studyunit-topics> -->
        <!-- </div>
      </div>
    </div>
  </div> -->

